const Dashboard = () => {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <h1 className="text-2xl font-bold">Welcome to admin panel!</h1>
        </div>
    );
};

export default Dashboard;
